<template>
  <div class="ecm__card">
    <div class="ecm__card-cover"
      @click="handleDetail(book.id, book.title)"
    >
      <img v-if="isCover" :src="isCover" alt="" @error="aVueFunctionThatChangesTheSrc">
      <i v-else class="fas fa-image"></i>
    </div>
    <div class="ecm__card-description">
      <p
        @click="handleDetail(book.id, book.title)"
        class="ecm__card-description_title"
      >
        {{ book.title }}
      </p>
      <p class="ecm__card-description_author">Author: <span>{{ book.Author.full_name }}</span></p>
      <div class="ecm__card-description_box">
        <p class="ecm__card-description_box-price">Rp {{ formatPrice(book.price) }}</p>
        <p class="ecm__card-description_box-wishlist" @click="setWishlist">
          <i v-if="!isWishlist" class="far fa-heart"></i>
          <i v-else class="fas fa-heart"></i>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Card_Component',
  props: {
    book: {
      type: Object
    }
  },
  computed: {
    isWishlist: {
      get () {
        return this.$props.book.is_wishlist
      },
      set (payload) {
        this.$props.book.is_wishlist = payload
      }
    },
    isCover: {
      get () {
        return this.$props.book.cover
      },
      set (payload) {
        this.$props.book.cover = payload
      }
    }
  },
  methods: {
    ...mapActions({
      fetchCount: 'wishlist/fetchCount',
      addWishlist: 'wishlist/addWishlist'
    }),
    handleDetail (id, title) {
      this.$router.push(`${id}/${title}`)
    },
    async setWishlist () {
      if (!localStorage.getItem('access_token')) {
        this.$router.push('/login')
      } else {
        try {
          const resp = await this.addWishlist({ bookId: this.$props.book.id })
          if (resp.msg === 'wishlist deleted') {
            this.isWishlist = false
          } else {
            this.isWishlist = true
          }
          this.fetchCount()
        } catch (error) {
          console.log(err.response.data)
        }
      }
    },
    formatPrice (value) {
      if (value !== undefined || value !== null) {
        value = +value
        const reverseValue = value.toString().split('').reverse().join('')
        let price = reverseValue.match(/\d{1,3}/g)
        price = price.join('.').split('').reverse().join('')
        return price
      } else {
        return '...'
      }
    },
    setIsWishlist (payload) {
      this.$data.isWishlist = payload
    },
    aVueFunctionThatChangesTheSrc (e) {
      if (e) {
        this.isCover = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__card {
  background: white;
  width: 100%;
  padding: 5px 7px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  flex-direction: column;
  transition: .2s;
  border: 1px solid white;
  .ecm__card-cover {
    overflow: hidden;
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(207, 203, 203, 0.116);
    cursor: pointer;
    img {
      width: 100%;
    }
    i {
      color: var(--color-blue-background);
    }
  }
  .ecm__card-description {
    margin-top: 7px;
    font-size: 13px;
    .ecm__card-description_title, .ecm__card-description_author {
      white-space: nowrap;
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .ecm__card-description_title {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .ecm__card-description_author {
      cursor: default;
      span {
        color: rgb(3, 48, 145);
        margin-left: 3px;
        font-weight: 500;
      }
    }
    .ecm__card-description_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 15px;
      .ecm__card-description_box-price {
        color: var(--color-pink);
        font-weight: 600;
        cursor: default;
      }
      .ecm__card-description_box-wishlist {
        width: 20px;
        text-align: center;
        cursor: pointer;
        i {
          color: red;
        }
      }
    }
  }
  &:hover {
    transform: translateY(-5px);
    border: 1px solid var(--color-yellow);
  }
}

@media screen and (max-width: 1024px) {
  .ecm__card {
    width: 155px;
    .ecm__card-cover {
      height: 210px;
      img {
        height: 100%;
      }
    }
    .ecm__card-description {
      font-size: 11px;
      word-break: break-all;
      .ecm__card-description_title {
        height: 27px;
      }
      .ecm__card-description_author {
        margin: 0;
        height: 18px;
        // span {
        //   width: 84px;
        // }
      }
      .ecm__card-description_box {
        font-size: 13px;
      }
    }
    &:hover {
      transform: none;
    }
  }
}

@media screen and (max-width: 768px) {
  .ecm__card {
    width: 115px;
    .ecm__card-cover {
      height: 155px;
    }
    .ecm__card-description {
      font-size: 9px;
      .ecm__card-description_title {
        height: 20px;
      }
      .ecm__card-description_author {
        height: 15px;
        margin: 0;
      }
      .ecm__card-description_box {
        font-size: 10px;
      }
    }
  }
}

@media screen and (max-width: 481px) {
  .ecm__card {
    padding: 3px 5px;
    width: 170px;
    .ecm__card-cover {
      height: 245px;
    }
    .ecm__card-description {
      font-size: 10px;
      .ecm__card-description_title {
        height: 24px;
      }
      .ecm__card-description_author {
        height: 17px;
      }
      .ecm__card-description_box {
        font-size: 12px;
      }
    }
  }
}

@media screen and (max-width: 320px) {
  .ecm__card {
    .ecm__card-cover {
      height: 200px;
    }
  }
}
</style>
